import { defineStore } from 'pinia'
import { useUserStore } from "@/stores/user";

export const useSupportStore = defineStore('support', {
  state: () => ({
    tickets: [],
    totalRecords: 0,
    loading: false,
    serverOptions: {
      page: 0,
      rows: 10,
    },
  }),
  actions: {
    async index() {
      this.loading = true

      try {
        const organisation = useUserStore().user.organisation
        const response = await this.apiClientV2.get('/support', {
          params: {
            kdnr: organisation?.kdnr,
            page: this.serverOptions.page + 1,
            rows: this.serverOptions.rows,
          },
        })

        const responseData = response?.data
        const tickets = Array.isArray(responseData)
          ? responseData
          : responseData?.tickets || []

        const totalRecords = Number(
          responseData?.totalRecords
          || tickets.length
        )

        this.tickets = tickets
        this.totalRecords = totalRecords

        return response
      } finally {
        this.loading = false
      }
    },
    get_articles(id) {
      return this.apiClientV2.get(`/support/${id}/get_articles`)
    },
    create_article(article) {
      return this.apiClientV2.post(`/support/${article.ticket_id}/create_article`, {
        article,
      })
    },
    create(ticket) {
      return this.apiClientV2.post('/support', {
        ticket,
      })
    },
  },
})
